export default __webpack_public_path__ + "5d8c2d6c287f888c2c7f0f0b3a341bd7.svg";